import { z } from 'zod';
/** How the client seems to feel about working with Clustox, estimated from a call transcript. */
export const SentimentLevelSchema = z.enum([
    'very_positive',
    'positive',
    'neutral',
    'negative',
    'very_negative',
    'unknown',
]);
export const SENTIMENT_LABELS = {
    very_positive: 'Very positive',
    positive: 'Positive',
    neutral: 'Neutral',
    negative: 'Negative',
    very_negative: 'Very negative',
    unknown: 'Unknown',
};
const MAX_REASON = 300;
const MAX_SIGNALS = 4;
const MAX_SIGNAL = 200;
const MeetingSentimentSchema = z.object({
    level: SentimentLevelSchema,
    reason: z.string().transform((s) => s.slice(0, MAX_REASON)),
    signals: z
        .array(z.string())
        .transform((a) => a.slice(0, MAX_SIGNALS).map((s) => s.slice(0, MAX_SIGNAL))),
});
/**
 * Sentiment as returned by the model. Missing or malformed values become
 * `unknown`, so a sentiment problem never rejects the whole post-call result.
 */
export const LenientSentimentSchema = MeetingSentimentSchema.catch({
    level: 'unknown',
    reason: '',
    signals: [],
});
export const SENTIMENT_AVERAGE_WINDOW = 5;
const SCORE = {
    very_negative: -2,
    negative: -1,
    neutral: 0,
    positive: 1,
    very_positive: 2,
};
const BY_SCORE = [
    'very_negative',
    'negative',
    'neutral',
    'positive',
    'very_positive',
];
const isKnown = (l) => l !== null && l !== 'unknown';
/**
 * Mean of all known sentiments. A mean exactly halfway between two levels
 * rounds toward the more negative one, so it never looks better than the data.
 */
export function meanSentiment(levels) {
    const known = levels.filter(isKnown);
    if (known.length === 0)
        return null;
    const mean = known.reduce((sum, l) => sum + SCORE[l], 0) / known.length;
    return { level: BY_SCORE[Math.ceil(mean - 0.5) + 2], basedOn: known.length };
}
/** Mean of the most recent known sentiments (pass levels newest first). */
export function averageSentiment(levelsNewestFirst) {
    return meanSentiment(levelsNewestFirst.filter(isKnown).slice(0, SENTIMENT_AVERAGE_WINDOW));
}
//# sourceMappingURL=sentiment.js.map